import { UserResponse } from '../../../providers/User/User.model';
import { BaseQueryParams } from '../../Global.model';
import { Driver } from '../driver/driver.model';
import { Equipment } from '../equipment/equipment.model';
import { OtherExpenseAttachment } from '../otherExpenseAttachment/otherExpenseAttachment.model';
import { Trip } from '../trips/trips.model';

// TODO: enable when filters are implemented
export interface OtherExpenseFilterParams {
  name?: string[];
  type?: OtherExpenseTypeEnum[];
  equipmentId?: string[];
  driverId?: string[];
  dateFromStart?: string | undefined;
  dateFromEnd?: string | undefined;
  dateToStart?: string | undefined;
  dateToEnd?: string | undefined;
  tripNumber?: string[];
  classification?: OtherExpenseClassificationEnum[];
  tripIds?: string[];
}

export interface SearchOtherExpensesParams {
  filters?: OtherExpenseFilterParams;
  params?: BaseQueryParams;
  token?: string;
}

export const DEFAULT_OTHER_EXPENSE_ITEMS_PER_PAGE = 10;
export type OtherExpenseFrequency = 'ONE_TIME' | 'WEEKLY';

// type
export type OtherExpenseType = 'SCALES' | 'TOLLS' | 'TRUCK_PARTS' | 'TRUCK_WASH' | 'OTHER';

export enum OtherExpenseTypeEnum {
  SCALES = 'SCALES',
  TOLLS = 'TOLLS',
  TRUCK_PARTS = 'TRUCK_PARTS',
  TRUCK_WASH = 'TRUCK_WASH',
  OTHER = 'OTHER'
}

export const OtherExpenseTypeValues = [
  OtherExpenseTypeEnum.SCALES,
  OtherExpenseTypeEnum.TOLLS,
  OtherExpenseTypeEnum.TRUCK_PARTS,
  OtherExpenseTypeEnum.TRUCK_WASH,
  OtherExpenseTypeEnum.OTHER
];

// classification
export type OtherExpenseClassification = 'DEDUCT_FROM_PAY' | 'REIMBURSE' | 'COMPANY_CHARGE';

export enum OtherExpenseClassificationEnum {
  DEDUCT_FROM_PAY = 'DEDUCT_FROM_PAY',
  REIMBURSE = 'REIMBURSE',
  COMPANY_CHARGE = 'COMPANY_CHARGE' // default selection
}

export const OtherExpenseClassificationValues = [
  OtherExpenseClassificationEnum.DEDUCT_FROM_PAY,
  OtherExpenseClassificationEnum.REIMBURSE,
  OtherExpenseClassificationEnum.COMPANY_CHARGE
];

export interface OtherExpense {
  id: string;
  name: string;
  type: OtherExpenseType | null;
  classification: OtherExpenseClassification;
  equipment_id: string | null;
  driver_id: string | null;
  trip_id: string | null;
  amount: number;
  date_from: Date;
  date_to: Date | null;
  tenant_id: string;
  frequency: OtherExpenseFrequency;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date | null;
  created_by: string | null;
  updated_by: string | null;
  deleted_by: string | null;
  createdBy: UserResponse | null;
}

export type OtherExpenseEditableAttributes =
  | 'id'
  | 'name'
  | 'type'
  | 'classification'
  | 'equipment_id'
  | 'driver_id'
  | 'trip_id'
  | 'amount'
  | 'date_from'
  | 'date_to'
  | 'frequency';

// export interface OtherExpenseAttachment extends LoadDocument {
//   other_expense_id: string;
// }

export type SearchOtherExpenseResponse = OtherExpense & {
  equipment: Pick<Equipment, 'id' | 'name' | 'type'> | null;
  driver: Pick<Driver, 'id' | 'first_name' | 'last_name'> | null;
  trip: Pick<Trip, 'id' | 'readable_id' | 'order_readable_id' | 'sort_order' | 'load_id'> | null;
  other_expense_attachments: OtherExpenseAttachment[];
};

export type GetExpenseByIdResponse = OtherExpense & {
  equipment: Pick<Equipment, 'id' | 'name' | 'type'> | null;
  driver: Pick<Driver, 'id' | 'first_name' | 'last_name'> | null;
  trip: Pick<Trip, 'id' | 'readable_id'> | null;
  createdBy: Pick<UserResponse, 'id' | 'first_name' | 'last_name'> | null;
  other_expense_attachments: OtherExpenseAttachment[];
};

export type CreateExpenseBody = Omit<
  OtherExpense,
  | 'id'
  | 'tenant_id'
  | 'created_at'
  | 'updated_at'
  | 'created_by'
  | 'updated_by'
  | 'deleted_by'
  | 'deleted_at'
  | 'createdBy'
>;

export interface CreateExpenseParams {
  body: CreateExpenseBody;
  token?: string;
}

export type CreateExpenseResponse = {
  data: OtherExpense;
  message: string;
};

export type UpdateExpenseBody = Partial<Pick<OtherExpense, OtherExpenseEditableAttributes>>;
export type UpdateExpenseResponse = {
  data: OtherExpense;
  message: string;
};

export interface UpdateExpenseParams {
  body: UpdateExpenseBody;
  token?: string;
}
